import _ from 'lodash';

// Ensure these values are set correctly
const meetsStandardizationCriteria = (anAddress) => anAddress.country === 'US';

const isStdSvcAvailable = (anAddress) => {
    return anAddress
        && (anAddress.mustStandardize_Ext === true || anAddress.mustStandardize_Ext === undefined)
        && meetsStandardizationCriteria(anAddress);
};

const isStdBtnAvailable = (anAddress, xPortal) => {
    if (xPortal === 'CC') {
        const x = ['validated', 'overridden'];
        return isStdSvcAvailable(anAddress) && !_.includes(x, anAddress.addressVerifyStatusExt);
    } else {
        return isStdSvcAvailable(anAddress)
            && ((_.isUndefined(anAddress.isNotValidated_Ext) || anAddress.isNotValidated_Ext === true)
            && !(anAddress.isValidated_Ext === true || anAddress.isOverridden_Ext === true));
    }
};

const showStatus = (anAddress, xPortal) => {
    if (xPortal === 'CC') {
        if (anAddress && anAddress.mustStandardize_Ext && anAddress.country === 'US') {
            return anAddress.addressVerifyStatusExt; 
        }
    } else {
        return anAddress && (anAddress.mustStandardize_Ext === true || anAddress.mustStandardize_Ext === undefined)
        && anAddress.country === 'US'
        && (anAddress.isValidated_Ext === true || anAddress.isOverridden_Ext === true
        || (_.isUndefined(anAddress.isNotValidated_Ext) || anAddress.isNotValidated_Ext === true));
    }
};

export default {
        'meetsStandardizationCriteria': meetsStandardizationCriteria,
        'isStdSvcAvailable': isStdSvcAvailable,
        'isStdBtnAvailable': isStdBtnAvailable,
        'showStatus': showStatus
}